import styled, { css } from 'styled-components';

import {
  DEFAULT_DESKTOP_HEADER_HEIGHT,
  DEFAULT_MOBILE_HEADER_HEIGHT,
} from '@/theme/dimensions';

import { Box } from './Box';

export const MainBox = styled(Box)<{ $headerHeight?: number }>`
  flex: 1;
  display: block !important;
  margin-top: ${({ $headerHeight }) =>
    $headerHeight != null && $headerHeight !== 0
      ? Math.max($headerHeight - 1, DEFAULT_MOBILE_HEADER_HEIGHT)
      : DEFAULT_MOBILE_HEADER_HEIGHT}px;

  ${({ $headerHeight, theme }) =>
    css`
      ${theme.media.md.up} {
        margin-top: ${$headerHeight != null && $headerHeight !== 0
          ? Math.max($headerHeight - 1, DEFAULT_DESKTOP_HEADER_HEIGHT)
          : DEFAULT_DESKTOP_HEADER_HEIGHT}px;
      }
    `}
`;
